import { FC, ReactElement } from 'react'
import classnames from 'classnames'

import { MaterialIcon } from '@/components'
import { formatDate } from '@/helpers/date'
import { trans } from '@/helpers/trans'
import { SpecialDayViewModel } from '@/models/SpecialDay'

import './SpecialDaysList.scss'

interface SpecialDaysListProps {
    specialDays: SpecialDayViewModel[]
    multipleDays?: boolean
    className?: string
}

export const SpecialDaysList: FC<SpecialDaysListProps> = ({
    specialDays,
    multipleDays = false,
    className = '',
}): ReactElement => {
    const listClassName = classnames('special-days-list', {
        'special-days-list--multiple-days': multipleDays,
        'special-days-list--single-day': ! multipleDays,
    }, className)

    return (
        <div className={listClassName}>
            <p className="special-days-list__message">
                {
                    multipleDays
                        ? trans('containers.specialDaysList.multipleDaysWarning')
                        : trans('containers.specialDaysList.singleDayWarning')
                }
            </p>
            <ul className="special-days-list__list">
                {specialDays.map(specialDay => (
                    <li key={specialDay.id} className="special-days-list__list-item">
                        <div className="special-days-list__content">
                            <MaterialIcon
                                kind={specialDay.type}
                                fontSize={16}
                                className="special-days-list__icon"
                            />
                            {
                                multipleDays
                                    ? `${specialDay.description} (${formatDate(specialDay.date, 'd MMMM')})`
                                    : specialDay.description
                            }
                        </div>
                    </li>
                ))}
            </ul>
        </div>
    )
}
